/* Refresh presentation only when Back restores a cached storefront page. */
(() => {
  let refreshing = false;
  window.addEventListener('pageshow', async event => {
    const navigation = window.performance?.getEntriesByType('navigation')[0];
    if ((!event.persisted && navigation?.type !== 'back_forward') || refreshing) return;
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    if (!inner) return;
    const before = inner.innerHTML;
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 10000);
    refreshing = true;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
      const response = await fetch(url.href, {
        method: 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: abort.signal
      });
      if (!response.ok) return;
      const sections = await response.json();
      const parser = new DOMParser();
      const freshDrawer = typeof sections['cart-drawer'] === 'string'
        ? parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer') : null;
      const freshInner = freshDrawer?.querySelector('.drawer__inner');
      const freshIcon = typeof sections['cart-icon-bubble'] === 'string'
        ? parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section') : null;
      // Never overwrite a newer add/remove response or clear working UI on failure.
      if (!freshInner || !freshIcon || !inner.isConnected || inner.innerHTML !== before) return;
      inner.innerHTML = freshInner.innerHTML;
      inner.className = freshInner.className;
      drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      const icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.innerHTML = freshIcon.innerHTML;
      // Keep the native drawer, overlay handlers and open/closed state intact.
      // This code never adds, removes, changes or submits an order.
    } catch (_) {
      // A failed refresh must not erase the cart or retry a purchase action.
    } finally {
      clearTimeout(timeout);
      refreshing = false;
    }
  });
})();
